import React from 'react';

const SubBoxIcon = props => (
	<svg width="19" height="19" viewBox="0 0 19 19" {...props}>
		<path d="M10.834 10.7l8.352-4.99L9.592.112a.834.834 0 0 0-.849.006L.833 4.865l10.001 5.834zM10 12.5L0 6.667v7.02c0 .296.158.571.413.72L10 20v-7.5zm1.667-.02v7.46l7.977-5.584a.832.832 0 0 0 .356-.683V7.5l-8.333 4.98z"/>
	</svg>
);

export default SubBoxIcon;
